import Vue from 'vue'
import SpinnerService from './SpinnerService.vue'

let LoadingConstructor = Vue.extend(SpinnerService);
let instance;
let instances = [];
let seed = 1;

LoadingConstructor.prototype.close = function () {
    if (instances.length > 0) {
        instances.forEach((i) => {
            if (document.body.contains(i.vm.$el))
                document.body.removeChild(i.vm.$el)
        })

        instances = []
        seed = 1
    }
}


var Loading = function (options) {

    // One Message at a time
    // Remove any existing message
    if (instances.length > 0) {
        instances.forEach((i) => {
            if (document.body.contains(i.vm.$el))
                document.body.removeChild(i.vm.$el)
        })

        instances = []
        seed = 1
    }

    options = options || {};
    if (typeof options === 'string') {
        options = {
            message: options
        };
    }

    instance = new LoadingConstructor({
        data: options
    });

    let id = 'message_' + seed++;
    instance.id = id;

    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);

    instances.push(instance);
    return instance.vm;
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/VueStyleGuide/Components/Spinner/service.js